import { motion } from "framer-motion";
import { maskLine } from "./Reveal";

export default function PageHero({ eyebrow, title, sub, image }) {
  return (
    <section className="relative flex min-h-[62vh] items-end overflow-hidden pb-16 pt-36">
      <motion.div
        className="absolute inset-0"
        initial={{ scale: 1.12, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
      >
        <img src={image} alt="" className="h-full w-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0908]/80 via-[#0A0908]/55 to-[#0A0908]" />
      <div className="relative mx-auto w-full max-w-7xl px-5 sm:px-8">
        {eyebrow && (
          <motion.p
            className="eyebrow"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.7 }}
          >
            {eyebrow}
          </motion.p>
        )}
        <h1 className="mt-4 overflow-hidden font-display text-4xl font-bold leading-[1.05] sm:text-5xl lg:text-6xl">
          <motion.span
            className="block text-gold-grad"
            variants={maskLine}
            custom={0}
            initial="hidden"
            animate="show"
          >
            {title}
          </motion.span>
        </h1>
        {sub && (
          <motion.p
            className="mt-5 max-w-2xl text-sm leading-relaxed text-stone-300 sm:text-base"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.45, duration: 0.7 }}
          >
            {sub}
          </motion.p>
        )}
      </div>
    </section>
  );
}
